import React from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icons from 'react-bootstrap-icons';

import { useCookies } from '../../../common/hooks/useCookies';
import { useTranslation } from '../../../common/hooks/useTranslation';

export const UserMemosHeader = (props: {
  onboarding: boolean;
  showNew: boolean;
  onNewMemo: () => void;
  onCloseMemo: () => void;
}) => {
  const cookies = useCookies();
  const { t, tk } = useTranslation('commonLng');

  return (
    <Modal.Header closeButton>
      {props.onboarding ? (
        <Modal.Title>{t(tk.memo.noMessageInSystem)}</Modal.Title>
      ) : props.showNew ? (
        <Button variant="outline-secondary" onClick={props.onCloseMemo}>
          <Icons.ChevronLeft />
        </Button>
      ) : (
        <div className="flex-fill d-flex justify-content-between">
          <Button variant="outline-primary" onClick={props.onNewMemo}>
            {t(tk.memo.newMessage)}
          </Button>
          <span className="mh-100 p-1">
            <OverlayTrigger
              overlay={
                <Tooltip>
                  {cookies.soundEnabled
                    ? t(tk.memo.turnOff)
                    : t(tk.memo.turnOn)}{' '}
                  {t(tk.memo.newMessageSound)}
                </Tooltip>
              }
            >
              {cookies.soundEnabled ? (
                <Icons.VolumeUpFill
                  size={20}
                  onClick={() => cookies.setSoundEnabled(false)}
                />
              ) : (
                <Icons.VolumeMuteFill
                  size={20}
                  onClick={() => cookies.setSoundEnabled(true)}
                />
              )}
            </OverlayTrigger>
          </span>
        </div>
      )}
    </Modal.Header>
  );
};
